import CsPanel from './CsPanel.vue'
CsPanel.install = function (Vue) {
  Vue.component(CsPanel.name, CsPanel)
}

import IndexPanel from './IndexPanel.vue'
IndexPanel.install = function (Vue) {
  Vue.component(IndexPanel.name, IndexPanel)
}

import ToolPanel from './ToolPanel.vue'
ToolPanel.install = function (Vue) {
  Vue.component(ToolPanel.name, ToolPanel)
}

import WsPanel from './WsPanel.vue'
WsPanel.install = function (Vue) {
  Vue.component(WsPanel.name, WsPanel)
}

import UdPanel from './UdPanel.vue'
UdPanel.install = function(Vue) {
  Vue.component(UdPanel.name,UdPanel)
}

import PartPanel from './PartPanel.vue'
PartPanel.install = function(Vue) {
  Vue.component(PartPanel.name,PartPanel)
}

export default [CsPanel,IndexPanel,ToolPanel,WsPanel,UdPanel,PartPanel]



// WEBPACK FOOTER //
// ./src/components/panel/index.js